import { useCallback } from 'react'
import { any } from 'ramda'

import { EncashmentsAction, EncashmentsStatusAction } from 'app/dataTypes/reports/data/finances/encashments/action'
import SimpleDate from 'app/common/classes/simple-date'


interface Options {
  actionCb: (params: EncashmentsStatusAction) => Promise<boolean>,
  selection: Set<string> | Array<string>,
  action: null | EncashmentsAction,
  date: SimpleDate
}
export function useEncashmentsActionsAll({
  actionCb,
  selection,
  action,
  date
}: Options
) {
  const actionAll = useCallback(async (comment?: string) => {
    if (!action) return false
    const array = Array.from(selection)
    const res = await Promise.all(array.map(ID => actionCb({ salePointId: ID, date, comment, action })))
    return any(Boolean, res)
  }, [actionCb, selection, date, action])

  return actionAll
}

